import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
import { Icon } from '../components/Icon';
import { buildTitle } from '../lib/site';
import { useT } from '../i18n';

export function NotFoundPage() {
  const t = useT();
  const p = t.pages.notFound;
  return (
    <>
      <Seo title={buildTitle(p.title)} path="/404" />
      <section className="page-header" style={{ padding: '100px 0 80px' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <div className="orb-404" aria-hidden="true">
            <div className="orb-core">404</div>
          </div>
          <span className="eyebrow" style={{ justifyContent: 'center' }}>{p.eyebrow}</span>
          <h1 style={{ fontSize: 'clamp(40px, 7vw, 72px)', marginTop: 18 }}>{p.title}</h1>
          <p style={{ margin: '20px auto 32px', maxWidth: 480 }}>{p.desc}</p>
          <div className="hero-cta" style={{ justifyContent: 'center' }}>
            <Link to="/" className="btn btn-primary btn-large">
              {p.backToSwap}
              <Icon name="arrow-right" width={18} height={18} />
            </Link>
            <Link to="/coins" className="btn btn-outline btn-large">{p.browseCoins}</Link>
          </div>
        </div>
      </section>
    </>
  );
}
